import { render, staticRenderFns } from "./HandlerUserEdit.vue?vue&type=template&id=c4b971b0"
import script from "./HandlerUserEdit.vue?vue&type=script&lang=js"
export * from "./HandlerUserEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports